import React from "react";
import PageHero from "../components/PageHero";
import WhyProspera from "../components/WhyProspera";
import HowWeWork from "../components/HowWeWork";
import Services from "../components/Services";
import Contact from "../components/Contact";
import { IMAGES } from "../config/siteConfig";

export default function Employers() {
  return (
    <>
      <PageHero
        label="For Businesses"
        title="Looking for a partner who can"
        highlight="ship software?"
        subtitle="Partner with INRISOFT for application development, product engineering, consulting and managed websites — with hyper support after go-live."
        image={IMAGES.employers}
      />
      <WhyProspera />
      <Services />
      <HowWeWork />
      <Contact />
    </>
  );
}
